module.exports = __webpack_public_path__ + "resources/09081ce222f8399dfb2c84077cf189ca.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/super-move.png
// module id = 224
// module chunks = 0